import React from 'react'
import './SnakeGame.css'

function GameBlock({ x, y, bkgColor, xmax, ymax }) {
    const percentnum = (x, xtot) => {return Math.trunc(x * 100000 / xtot) / 1000;}

    const relx = `${percentnum(x, xmax)}%`;
    const rely = `${percentnum(y, ymax)}%`;
    const relw = `${percentnum(x+1, xmax) - percentnum(x, xmax) + 0.002}%`;
    const relh = `${percentnum(y+1, ymax) - percentnum(y, ymax) + 0.002}%`;
    return (
        <div className='gameblock' style={{ background: bkgColor, top: rely, left: relx, width: relw, height: relh }}></div>
    );
}

function GameBoard({ width, height, snake, apple, colors }) {
    const aspectRatio = width / height;
    return (<>
        <div className='gameboard' style={{ aspectRatio: aspectRatio }}>
            {snake.toReversed().map((snakePart, index) => {
                return (
                    <GameBlock
                        x={snakePart.Xpos} y={snakePart.Ypos}
                        xmax={width} ymax={height}
                        bkgColor={(index === snake.length - 1) ? colors.head : colors.body}
                    />
                )
            })}
            <GameBlock
                x={apple.Xpos} y={apple.Ypos}
                xmax={width} ymax={height}
                bkgColor={colors.apple}
            />
        </div>
    </>);
}

function GameScore({ playerName, score, timeDuration, highscore }) {
    return (<>
        <div className='gameinfo'>
            {playerName}, Score {score}, ({timeDuration} s), high local score {highscore}
        </div>
    </>)
}

function GameOverBlock({display}) {
    if (!display)
        return (<></>)
    return (<><div className='gameoverblock'>
        Game Over! Press Space to restart the game.
        </div></>);
}

class SnakeGame extends React.Component {
    constructor(props) {
        super(props)

        this.handleKeyDown = this.handleKeyDown.bind(this)

        this.state = {
            width: 30,
            height: 20,
            startSnakeSize: this.props.startSnakeSize || 5,
            direction: [1, 0],
            handleDirection: [1, 0],
            snake: [],
            apple: {},
            timeoutId: 0,
            gameLoopTimeout: this.props.loopTimeout,
            playerName: this.props.playerName,
            localHighScore: Number(localStorage.getItem('snakeHighScore')) || 0,
            colors: {},
        }
    }

    componentDidMount() {
        this.initGame()
        window.addEventListener('keydown', this.handleKeyDown)
        this.gameLoop()
    }

    componentWillUnmount() {
        clearTimeout(this.state.timeoutId)
        window.removeEventListener('keydown', this.handleKeyDown)
    }

    initGame() {
        // snake initialization
        let snake = []
        const XposHead = Math.floor(this.state.width / 2)
        const YposHead = Math.floor(this.state.height / 2)
        for (let i = 0; i < this.state.startSnakeSize; i++)
            snake.push({ Xpos: XposHead - i, Ypos: YposHead })

        // apple position initialization
        const apple = this.placeAppleOnBoard(snake)

        this.setState({
            snake,
            apple,
            isGameOver: false,
            score: 0,
            starttime: Math.floor(Date.now() / 1000),
            colors: {
                body: this.props.snakeColor || this.getRandomColor(),
                head: this.props.headColor || this.getRandomColor(),
                apple: this.props.appleColor || this.getRandomColor(),
            },
        })
    }

    gameLoop() {
        let timeoutId = setTimeout(() => {
            if (!this.state.isGameOver) {
                const detachedBodyPart = this.moveSnake()
                this.tryToEatSnake()
                this.tryToEatApple(detachedBodyPart)
                this.gameLoop();
            }
        }, this.state.gameLoopTimeout);

        this.setState({ timeoutId })
    }

    resetGame() {
        this.initGame();
        this.gameLoop()

        this.setState({
            direction: [1, 0],
            handleDirection: [1, 0],
            gameLoopTimeout: this.props.loopTimeout,
        });
        this.sendData();
    }

    getRandomColor() {
        let hexa = '0123456789ABCDEF'
        let color = '#'
        for (let i = 0; i < 6; i++) color += hexa[Math.floor(Math.random() * 16)]
        return color
    }

    placeApple() {
        const Xpos = Math.floor(Math.random() * this.state.width)
        const Ypos = Math.floor(Math.random() * this.state.height)
        return [Xpos, Ypos]
    }

    placeAppleOnBoard(snake) {
        let coords = this.placeApple();

        while (this.isAppleOnSnake(coords[0], coords[1], snake)) {
            coords = this.placeApple();
        }
        return { Xpos: coords[0], Ypos: coords[1] }
    }

    moveSnake() {
        let snake = this.state.snake;
        const velocity = this.chooseVelocity(this.state.direction, this.state.handleDirection)
        const head = this.newHead(velocity);
        snake.unshift(head);
        const detachedBodyPart = snake.pop();

        this.setState({ snake, direction: velocity });
        return detachedBodyPart;
    }

    tryToEatApple(detachedBodyPart) {
        let snake = this.state.snake
        let apple = this.state.apple

        // if the snake's head is on an apple
        if (snake[0].Xpos === apple.Xpos && snake[0].Ypos === apple.Ypos) {
            let gameLoopTimeout = this.state.gameLoopTimeout

            // increase snake size
            snake.push(detachedBodyPart)

            // create another apple
            const apple = this.placeAppleOnBoard(snake)

            // increment high score if needed
            const newScore = this.state.score + 1

            // decrease the game loop timeout
            if (gameLoopTimeout > 25) gameLoopTimeout -= 0.5

            this.setState({
                snake,
                apple,
                score: newScore,
                localHighScore: Math.max(this.state.localHighScore, newScore),
                gameLoopTimeout,
            })
            this.sendData()
        }
    }

    tryToEatSnake() {
        let snake = this.state.snake

        for (let i = 1; i < snake.length; i++) {
            if (snake[0].Xpos === snake[i].Xpos && snake[0].Ypos === snake[i].Ypos) {
                this.setState({ isGameOver: true })
                this.sendData()
            }
        }
    }

    isAppleOnSnake(appleXpos, appleYpos, snake) {
        for (let i = 0; i < snake.length; i++) {
            if (appleXpos === snake[i].Xpos && appleYpos === snake[i].Ypos)
                return true
        }
        return false
    }

    newCoord(X0, dX, Xmax) {
        let Xnew = (X0 + dX) % Xmax
        if (Xnew < 0) {
            return Xmax + Xnew
        }
        return Xnew;
    }

    chooseVelocity(currentDirection, newDirection) {
        const velCur = currentDirection;
        const velNew = newDirection;

        if ((velNew[0] === -velCur[0]) && (velNew[1] === -velCur[1]))
            return velCur;

        return velNew;
    }

    newHead(velocity) {
        const { Xpos, Ypos } = this.state.snake[0]
        const newX = this.newCoord(Xpos, velocity[0], this.state.width);
        const newY = this.newCoord(Ypos, velocity[1], this.state.height);

        // console.log(newX, newY)
        return { Xpos: newX, Ypos: newY }
    }

    handleKeyDown(event) {
        // if spacebar is pressed to run a new game
        if (this.state.isGameOver && event.keyCode === 32) {
            this.resetGame()
            return
        }

        let handleDirection = this.state.handleDirection
        switch (event.keyCode) {
            case 37:
            case 65:
                handleDirection = [-1, 0];
                break
            case 38:
            case 87:
                handleDirection = [0, -1];
                break
            case 39:
            case 68:
                handleDirection = [1, 0];
                break
            case 40:
            case 83:
                handleDirection = [0, 1];
                break
            default:
                return
        }
        if (!this.state.isGameOver)
            this.setState({ handleDirection })
    }

    sendData() {
        setTimeout(() => {
            this.props.sendData({
                score: this.state.score,
                gameDuration: Math.floor(Date.now() / 1000) - this.state.starttime,
                isGameOver: this.state.isGameOver
            })
        }, 100);
    }

    render() {
        // Game over
        // if (this.state.isGameOver) {
        //     const gameSeconds = Math.floor((this.state.endTime - this.state.startTime) / 1000);
        //     return (
        //         <GameOver
        //             width={this.state.width}
        //             height={this.state.height}
        //             highScore={this.state.highScore}
        //             newHighScore={this.state.newHighScore}
        //             name={this.state.playerName}
        //             score={this.state.score}
        //             gameTime={gameSeconds}
        //         />
        //     )
        // }

        const gameDuration = Math.floor(Date.now() / 1000) - this.state.starttime
        return (<>
        <GameOverBlock display={this.state.isGameOver}/>
        <GameBoard
            width={this.state.width} height={this.state.height}
            snake={this.state.snake} apple={this.state.apple}
            colors={this.state.colors} />
            <GameScore playerName={this.state.playerName} score={this.state.score} timeDuration={gameDuration} highscore={this.state.localHighScore} />
        </>);
    }
}

export default SnakeGame
